import Service from "./Service";
import ServiceDetails from "./ServiceDetails/ServiceDetails";
import { useAppSelector } from "@/stores/hook";

export default function ServiceIndex() {
  const { isServiceDetails } = useAppSelector(
    (state) => state.videoProductionFunctional
  );

  if (isServiceDetails) {
    return (
      <div className="m-4">
        <ServiceDetails />
      </div>
    );
  }

  return (
    <div className="m-4">
      <Service />
    </div>
  );
}
